module.exports = __webpack_public_path__ + "assets/2482a6b52547be007bf6b3b5a4d6686c.png";